'use strict';

export class List {
	constructor(component_key) {
		this.id = component_key;
		this.component = yalwa.v.components[component_key];
		this.data = {};
		this.send_data = {};
		this.api = '';
		this.action = '';
		this.$root = jQuery(`.js-${this.id}`);
		this.$action = this.$root.find(`.js-${this.id}_action`);
	}
	
	init() {
		this.add_events();
	}
	
	// Abstract method: should be implemented by subclasses
	add_events() {
		throw new Error("Method 'add_events()' must be implemented in the subclass.");
	}
}
Object.keys(yalwa.v.components).map(async component_key => {
	if (component_key.startsWith('list_')) {
		try {
			const class_name = yalwa.basics.to_pascal_case(component_key);
			// import
			const module = await import(`./${component_key}.js`);
			// instantiate and initialize
			const component_class = module[class_name];
			new component_class(component_key).init();
		} catch (error) {
			console.error(`Failed to load or initialize class for ${component_key}:`, error);
		}
	}
})

